import { Container } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { CompanyListSelector } from 'src/organization/components/CompanyListSelector';
import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';
import { useGetCompanyList } from 'src/organization/hooks/useGetCompanyList';

export const CompanyRequiredGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslation('organization');
  const { activeCompany, isLoadingActiveCompany, setActiveCompany } =
    useActiveCompany();

  const { isLoading, items } = useGetCompanyList({
    enabled: !isLoadingActiveCompany && !activeCompany,
  });

  if (!activeCompany) {
    return (
      <Container maxWidth="sm" sx={{ mt: '10vh' }}>
        <Helmet>
          <title>{t('SELECT_COMPANY')}</title>
        </Helmet>
        <CompanyListSelector
          isLoading={isLoading}
          items={items}
          onSelectItem={(item) => {
            setActiveCompany(item.id);
            window.location.reload();
          }}
        />
      </Container>
    );
  }

  return <>{children}</>;
};
